import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http'

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/timeout';

const TIMEOUT_HEADER_NAME = 'timeout';
export class DefaultHttpInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeout = request.headers.get(TIMEOUT_HEADER_NAME);
    const customConfig = {};
    customConfig['withCredentials'] = true;

    if (timeout) {
      customConfig['headers'] = request.headers.delete(TIMEOUT_HEADER_NAME);
      return next.handle(request.clone(customConfig)).timeout(Number(timeout));
    }
    return next.handle(request.clone(customConfig));
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/interceptors/default-http.interceptor.ts